// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Kw1t","content":"styles_content__1Ma57","row":"styles_row__3cV_1","footer":"styles_footer__3hIQC","phraseLength":"styles_phraseLength__1EYHX"};